import React, {useContext} from "react";
import PropTypes from "prop-types";
import Context from "../IndexPage/Context";

const TruncatedPages = ({
	truncatedPages,
}) => {
	const {
		data: { currentPageNumber },
		actions: { handleButtonPageSelect, setCurrentPageNumber},
	} = useContext(Context);

	return (
		<div className="numbers-wrapper">
			{truncatedPages.map((page, i) => {
				return typeof page !== "number" ? (
					<p
						key={i}
						className={`number ${
							currentPageNumber === page ? "current" : ""
						}`}
					>
						{page}
					</p>
				) : (
					<a
						href=""
						className={`number ${
							currentPageNumber === page ? "current" : ""
						}`}
						onClick={(event) => {
							handleButtonPageSelect(page, setCurrentPageNumber, event);
						}}
						key={i}
					>
						{page}
					</a>
				);
			})}
		</div>
	);
};

TruncatedPages.propTypes = {
	truncatedPages: PropTypes.array,
};

export default TruncatedPages;
